<template>
  <section>
    <div v-show="edited" class="editForm">
      <p class="mt-2" v-for="(object,index) in details.items" :key="index">
        {{ object.title }}: {{object.text}} 
      </p>
      <i class="fal fa-times-circle" @click="removeEdit" v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
    </div>
    <b-card no-body v-show="!edited" class="mt-2">
      <b-card-body>
        <b-row v-for="(object,index) in details.items" :key="index">
          <b-col sm="3" class="text-right">
            <label>{{ object.title }}</label>
          </b-col>
          <b-col sm="9">
             <b-input v-model="object.text" type="text"></b-input>
          </b-col>
        </b-row>
      </b-card-body>      
      <b-card-footer>
        <b-button class="float-right mt-2 btn-fill" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
export default {
  props: ["value","templateId"],
  data() {
    return {
      edited: 0,
      details: this.value,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      let answers = [];
      this.edited = 1;      
      for (let ix = 0; ix < this.details.items.length; ix++) {
        let object = this.details.items[ix];            
        answers.push({
          key: object.id,
          value: object.text
        });
      }
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
        templateId: this.templateId,
        answers: answers
      })
      .then(function() {
        self.edited = 1;
      })
      .catch(function() {
        self.edited = 0;
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      });
    },
    removeEdit: function() {
      this.edited = 0;
    }
  },
  mounted() {
    for (let ix = 0; ix < this.details.items.length; ix++) {
      let object = this.details.items[ix];
      if(object.edited == "1")
      {
        this.edited = 1;
      }
    }
  }
};
</script>
<style>
</style>